goog.module('yext.location.Address');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const TextField = goog.require('yext.textfield.TextField');
const StringOption = goog.require('yext.location.variant.StringOption');
const helpers = goog.require('yext.location.helpers');

/**
 * @param {!jQuery} $ctx The field context, or a parent container
 * @constructor
 */
const Address = function($ctx) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-entity-address-field').addBack().filter('.js-entity-address-field');
  this.$edit = this.$field.find('.js-entity-address-field-edit');
  this.$line1 = this.$field.find('.js-address-line-1');
  this.$line2 = this.$field.find('.js-address-line-2');
  this.$extraDescription = this.$field.find('.js-address-extra-description');
  this.$city = this.$field.find('.js-address-city');
  this.$region = this.$field.find('.js-address-region');
  this.$sublocality = this.$field.find('.js-address-sublocality');
  this.$postalCode = this.$field.find('.js-address-postal-code');
  this.$fieldValue = this.$field.find('.js-entity-address-value');
  this.$dialog = this.$field.find('.js-invalid-address-dialog');

  // Map the instance to the element
  this.$field.data('address', this);

  this.addressLine = this.$edit.data('addressLine');
  this.addressLines = this.$edit.data('addressLines');
  this.countryCode = this.$edit.data('countryCode');
  this.timestamp = this.$edit.data('timestamp');
  this.badAddress = this.$edit.data('badAddress');
  this.badAddressMessageTemplate = this.$field.find('.js-bad-address-message-template').html();
  this.badGeocodeOverride = false;

  this.bindSubFields();
  this.storeValue();
  this.bindAddDisplayAddress();
};

/**
 * Bind/construct address sub-fields
 */
Address.prototype.bindSubFields = function() {
  var self = this;

  this.line1 = new TextField(this.$line1);
  this.line2 = new TextField(this.$line2);
  this.extraDescription = new TextField(this.$extraDescription);
  this.city = new TextField(this.$city);
  this.postalCode = new TextField(this.$postalCode);
  this.region = new StringOption(this.$region);

  if (this.$sublocality.length) {
    this.sublocality = new TextField(this.$sublocality);
  }

  $(this.getStringSubFields()).on('update.textField', function() {
    self.onUpdate();
  });

  $(this.region).on('updated', function() {
    self.onUpdate();
  });
};

/**
 * Triggered when the field is updated
 */
Address.prototype.onUpdate = function() {
  this.setFieldValue();
  this.emitUpdate();
};

/**
 * Set the hidden input to the field's JSON value
 */
Address.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getData()));
};

/**
 * Store the subfield values
 */
Address.prototype.storeValue = function() {
  this.getStringSubFields().forEach(function(f) {
    f.saveValue();
  });
  this.region.storeValue();
};

/**
 * Get all string sub fields
 * @return {!Array}
 */
Address.prototype.getStringSubFields = function() {
  var f = [this.line1, this.line2, this.extraDescription, this.city, this.postalCode];
  if (this.sublocality) {
    f.push(this.sublocality);
  }
  return f;
};

/**
 * Emit an updated message whenever any of the sub-fields have been updated
 */
Address.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Emit an submit field message for when this is triggered by abnormal means.
 * Ex. The user accepting a bad address
 */
Address.prototype.emitSubmitField = function() {
  $(this).trigger('submitField');
};

/**
 * Bind the toggle display address links
 */
Address.prototype.bindAddDisplayAddress = function() {
  var self = this;
  var $addDisplayAddress = this.$field.find('.js-add-display-address');
  var $hideDisplayAddress = this.$field.find('.js-hide-display-address');

  $addDisplayAddress.click(function() {
    self.$extraDescription.show();
    $addDisplayAddress.hide();
    self.extraDescription.focus();
  });

  $hideDisplayAddress.click(function() {
    $addDisplayAddress.show();
    self.$extraDescription.hide();
  });
};

/**
 * Empty all the sub field values
 */
Address.prototype.clear = function() {
  this.getStringSubFields().forEach(function(f) {
    f.clear();
  });
  this.region.clear();
};

/**
 * Set the address field values
 * @param {!Object} field Plain object version of the field data
 */
Address.prototype.set = function(field) {
  this.line1.set(field['line1']);
  this.line2.set(field['line2']);
  this.extraDescription.set(field['extraDescription']);
  this.city.set(field['city']);
  this.postalCode.set(field['postalCode']);
  this.region.set(field['region']);
  if (this.sublocality) {
    this.sublocality.set(field['sublocality']);
  }
  this.timestamp = field['timestamp'];
  // For address display purposes
  this.addressLine = field['addressLine'];
  this.addressLines = field['addressLines'];
  this.badAddress = !!field['badAddress'];

  // Reset the state of this flag
  this.badGeocodeOverride = false;
};

/**
 * Empty all the sub field values
 */
Address.prototype.reset = function() {
  this.getStringSubFields().forEach(function(f) {
    f.reset();
  });
  this.region.reset();
};

/**
 * Get the field's value, keyed on strings for JSON
 */
Address.prototype.getData = function() {
  var data = {
    'line1': this.line1.coreData(),
    'line2': this.line2.coreData(),
    'extraDescription': this.extraDescription.coreData(),
    'city': this.city.coreData(),
    'postalCode': this.postalCode.coreData(),
    'region': this.region.getData(),
    'countryCode': this.countryCode,
    'timestamp': this.timestamp,
  };
  if (this.sublocality) {
    data['sublocality'] = this.sublocality.coreData();
  }
  if (this.badGeocodeOverride) {
    data['badGeocodeOverride'] = true;
  }
  return data;
};

/**
 * Join address lines for rendering display mode
 * @return {string} HTML for display mode
 */
Address.prototype.getDisplayValue = function() {
  if (this.isEmpty()) {
    return helpers.emptyFieldMessage();
  } else if (this.isIndeterminate()) {
    return helpers.variousContentMessage();
  }
  var html = '<div class="entity-address-display">';
  if (this.badAddress) {
    html += this.badAddressMessageTemplate;
  }
  html += '<div class="address-line" tid="address-line">';
  html += this.addressLines.join('</div><div class="address-line" tid="address-line">');
  html += '</div></div>';
  return html;
};

/**
 * Return true if all of the sub-fields are empty
 */
Address.prototype.isEmpty = function() {
  var empty = this.getStringSubFields().reduce(function(empty, f) {
    return empty && f.isEmpty();
  }, true);
  empty &= this.region.isEmpty();
  return empty;
};

/**
 * Return true if any of the sub-fields are indeterminate
 */
Address.prototype.isIndeterminate = function() {
  var indeterminate = this.getStringSubFields().reduce(function(indeterminate, f) {
    return indeterminate || f.isIndeterminate();
  }, false);
  indeterminate |= this.region.isIndeterminate();
  return indeterminate;
};

exports = Address;
